angular
  .module("erp.other.clickShopOpeningDetail", ["ui.router", "clickShopOpeningDetail.service"])
  .config([
    "$stateProvider",
    "$httpProvider",
    function($stateProvider, $httpProvider) {
      $httpProvider.defaults.headers.put["Content-Type"] = "application/json;charset=utf-8";
      $stateProvider.state("clickShopOpeningDetail", {
        url: "/erp/other/clickShopOpeningDetail",
        templateUrl: "tpl/outbox.htm",
        controllerAs: "vm",
        controller: "baseCtrl",
        resolve: {},
      });
    },
  ])

  .controller("baseCtrl", [
    "$scope",
    "$http",
    "$sce",
    "$q",
    "kit",
    "$timeout",
    function($scope, $http, $sce, $q, kit, $timeout) {
      var vm = this;
      // var params = kit.getParams();
      vm.tpl = "tpl/outbox.htm";
    },
  ])
  ;
